<script lang="ts">
  import type { Maybe, Font, LayoutSettings } from "../types";
  import { page } from "$app/stores";
  import { centcomApi } from "../env";
  import { fontStyleHtml, themeStyleHtml } from "../domain/theme";

  $: theme = $page.data.pageTheme;
  $: title = $page.data.pageTitle;
  $: description = $page.data.pageDescription;

  export let font: Maybe<Font>;
  export let settings: LayoutSettings;
</script>

<svelte:head>
  <title>{title}</title>

  {#if description}
    <meta name="description" content={description} />
  {/if}

  {#if settings.favicon}
    <link rel="icon" type="image/png" href={settings.favicon} />
  {/if}

  {#if theme}
    <meta name="theme-color" content={theme} />
  {/if}

  {@html themeStyleHtml(settings, $page.data)}

  {#if settings.touchIcon}
    <link rel="apple-touch-icon" href={settings.touchIcon} />
  {/if}

  <link rel="preconnect" href={centcomApi} />

  {#if font}
    <link rel="preconnect" href={font.preconnectUrl} />
    <link rel="stylesheet" href={font.resourceUrl} />
    {@html fontStyleHtml(font)}
  {/if}
</svelte:head>
